import { Divider, Grid2, Tab, Tabs } from "@mui/material";
import DashboardLayout from "layouts/DashboardLayout";
import React, { useState } from "react";
import Group from "./Group";
import Telegram from "./Telegram";
import Template from "./Template";

const Communication = () => {
  const [communicationMainTabs, setCommunicationMainTabs] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setCommunicationMainTabs(newValue);
  };

  return (
    <DashboardLayout
      title={communicationMainTabs === 1 ? "Groups" : "Templates"}
    >
      <Grid2 container spacing={1}>
        <Grid2 size={12}>
          <Tabs
            variant="scrollable"
            value={communicationMainTabs}
            onChange={handleChange}
          >
            <Tab disableRipple label="Templates" />
            <Tab disableRipple label="Groups" />
            <Tab disableRipple label="Telegram" />
          </Tabs>
          <Divider />
        </Grid2>
        <Grid2 size={12}>
          {communicationMainTabs === 0 && <Template />}
          {communicationMainTabs === 1 && <Group />}
          {communicationMainTabs === 2 && <Telegram />}
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
};

export default Communication;
